#import "../../../../core/schema/fragments/CareerApplicationFull.graphql"

mutation (
  $input: CareerApplicationInput
) {
  createCareerApplication(
    input: $input
  ) {
    ...CareerApplicationFull
  }
}
